export default "__VITE_PUBLIC_ASSET__207c719c__"